<a (mouseover)="onMouseOver()" (mouseout)="onMouseOut()" (click)="changeState()"
    >{{ title }}
    <img
        [src]="iconSrc"
        [style.display]="upArrowState()"
        [style.padding-left.px]="11"
        [style.padding-right.px]="11"
        [style.transform]="upArrowTransform()" />
</a>
